export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Overview',
        to: 'Overview',
        icon: {
          src: require('@/assets/img/icon/overview.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Statistic & Analytics',
        to: 'StatisticAndAnalysis',
        icon: {
          src: require('@/assets/img/icon/chart.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        class: 'sidebar-item-text'
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Training & Customization',
      //   to: 'TrainingAndCustomization',
      //   icon: {
      //     src: require('@/assets/img/icon/training.png'),
      //     width: 15,
      //     height: 15,
      //     class: 'mr-3'
      //   },
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Customized Object Analytic',
        to: 'CustomizedObjectAnalytic',
        icon: {
          src: require('@/assets/img/icon/training.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
      },
    
      {
        _name: 'CSidebarNavItem',
        name: 'Camera Management',
        to: 'CameraInsight',
        icon: {
          src: require('@/assets/img/icon/camerablack.png'),
          width: 15,
          height: 15,
          class: 'mr-3'
        },
        class: 'sidebar-item-text'
      },
      
    
    
   
     
    ]
  },
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Setting',
        to: 'Setting',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logout',
        to: 'Logout',
      },
    ],
    _style: 'margin-top: auto;', // Pushes the navigation items to the bottom of the sidebar
  }
]